import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { CONFIG } from '../../environments/config';

@Injectable({
  providedIn: 'root'
})
export class SalesPersonService {

  constructor(private httpClientService: HttpClientService) { }


  public createSalesperson(data: any) {
    return this.httpClientService.post(`${CONFIG.SALESPERSON.CREATESALESPERSON}`,data);
  }

  public getAllSalesperson(data: any){
    return this.httpClientService.post(`${CONFIG.SALESPERSON.GETALLSALESPERSON}`,data);
  }
  public getSalespersonById(data: any)
  {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.SALESPERSON.GETSALESPERSON}?${queryParam}`);
  }
  public updateSalesperson(data: any) {
    return this.httpClientService.post(`${CONFIG.SALESPERSON.UPDATESALESPERSON}`,data);
  }

  public deleteSalesperson(data: any) {
    return this.httpClientService.post(`${CONFIG.SALESPERSON.DELETESALESPERSON}`,data);
  }
  public autogenerateSalespersonCode() {
    return this.httpClientService.get(CONFIG.SALESPERSON.AUTOGENERATE_SALESPERSONCODE);
  }
  public checkSalesPersonCode(data:any){
    return this.httpClientService.get(`${CONFIG.SALESPERSON.CHECK_SALESPERSON_CODE}?SalespersonCode=${data}`);
  }
  public autoSearchSalesPerson(seachkey:string){
    return this.httpClientService.get(`${CONFIG.SALESPERSON.AUTOSEARCHSALESPERSON}?searchText=${seachkey}`);
  }
  public uploadSalespersonImage(salespersonId:number,formData: FormData) {
    return this.httpClientService.post(`${CONFIG.SALESPERSON.UPLOAD_SALESPERSON_IMAGE}/${salespersonId} `, formData);
  }

}
